/* Keep My Hair Quiz — Nunca Mas Pelon
   ------------------------------------------------------------------
   Flow, branching and motion are modelled on the Keeps hair assessment:

     - single-select answers commit and advance immediately (no Continue)
     - a step can declare hideIf {field, op, value}; the "advance" routine
       recurses forward past every step whose condition hides it
     - leaving a step:  opacity 300ms ease -> 0, swap after 300ms
       entering a step: translateX(40px)/opacity 0 -> translateX(0)/opacity 1
                        over "500ms ease-out" with a 50ms delay
     - answers persist in sessionStorage under their field name

   Deliberate difference from Keeps: their "How would you like to treat your
   hair loss?" step (Oral Rx vs Topical Rx) is NOT reproduced — this store does
   not sell prescriptions. The final routing therefore keys on `priority`
   alone, where Keeps keyed on treatmentType x priority.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var root = document.getElementById('keep-my-hair-quiz');
  if (!root) return;

  var cfgEl = root.querySelector('[data-kq-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }

  var ENTER_MS = 500;   // Keeps: transform/opacity 500ms ease-out
  var ENTER_DELAY = 50; // Keeps: 50ms delay
  var LEAVE_MS = 300;   // Keeps: opacity 300ms ease, swap after 300ms

  /* ---------- flow -------------------------------------------------
     `field` is the answer key (also the sessionStorage key). Steps with no
     field are interstitials. Two steps share the field "picture" exactly as
     Keeps' two picture steps share hairLossPicture — that is what makes the
     "Not sure" -> alternate-grid -> kickout chain work. */
  var STEPS = [
    { id: 'goal',      field: 'goal' },
    { id: 'stage',     field: 'stage' },
    { id: 'picture',   field: 'picture' },
    { id: 'picture2',  field: 'picture',
      hideIf: { field: 'picture', op: 'notEquals', value: 'Not Sure' } },
    { id: 'kickout',   terminal: true,
      hideIf: { field: 'picture', op: 'notEquals', value: 'Mostly Scalp' } },
    { id: 'duration',  field: 'duration' },
    { id: 'comments',  field: 'comments' },
    { id: 'treated',   field: 'treated' },
    { id: 'results',   field: 'results',
      hideIf: { field: 'treated', op: 'notEquals', value: 'Yes' } },
    { id: 'progress' },          /* slide 8 — the reviews rail */
    /* slide 9 (treatment type) intentionally omitted */
    { id: 'priority',  field: 'priority' },
    { id: 'goodhands' },
    { id: 'analysis' },
    { id: 'loader1',   loader: { from: 0,  to: 54,  ms: 4200 } },
    { id: 'lead' },
    { id: 'loader2',   loader: { from: 55, to: 100, ms: 3600, last: true } }
  ];

  var answers = {};
  var history = [];
  var index = 0;
  var busy = false;
  var booted = false;

  /* ---------- storage ---------- */
  function readStore() {
    STEPS.forEach(function (s) {
      if (!s.field || answers[s.field] !== undefined) return;
      try {
        var v = sessionStorage.getItem('kq:' + s.field);
        if (v !== null) answers[s.field] = v;
      } catch (e) { /* private mode — memory only */ }
    });
  }
  function setAnswer(field, value) {
    answers[field] = value;
    try { sessionStorage.setItem('kq:' + field, value); } catch (e) {}
  }

  /* Position is persisted alongside the answers so that a reload — from a
     native form post, a back/forward, a flaky connection — resumes the quiz
     instead of restarting it with every answer still stored. */
  var STEP_KEY = 'kq:_step';
  function saveProgress() {
    try { sessionStorage.setItem(STEP_KEY, String(index)); } catch (e) {}
  }
  function clearProgress() {
    try { sessionStorage.removeItem(STEP_KEY); } catch (e) {}
  }
  function restoreProgress() {
    var raw;
    try { raw = sessionStorage.getItem(STEP_KEY); } catch (e) { return; }
    if (raw === null) return;
    var i = parseInt(raw, 10);
    if (isNaN(i) || i < 1 || i >= STEPS.length) return;
    /* Never resume onto a loader: its timer would fire on arrival and throw the
       visitor straight out of the quiz before they saw anything. */
    while (i > 0 && (STEPS[i].loader || hidden(STEPS[i]))) i--;
    index = i;
    history = [];
    for (var j = 0; j < index; j++) if (!hidden(STEPS[j])) history.push(j);
  }

  /* ---------- branching (Keeps' `nextIndex`, iterative) ---------- */
  function hidden(step) {
    var c = step.hideIf;
    if (!c) return false;
    var actual = answers[c.field];
    if (c.op === 'equals') return c.value === actual;
    if (c.op === 'notEquals') return c.value !== actual;
    return false;
  }
  function nextIndex(from) {
    var i = from + 1;
    while (i < STEPS.length && hidden(STEPS[i])) i++;
    return i;
  }
  function visibleSteps() {
    return STEPS.filter(function (s) { return !hidden(s); });
  }

  /* ---------- DOM ---------- */
  var slides = root.querySelector('[data-kq-slides]');
  var backBtn = root.querySelector('[data-kq-back]');
  var bar = root.querySelector('[data-kq-progress]');
  var countEl = root.querySelector('[data-kq-count]');
  var stepEls = {};
  Array.prototype.forEach.call(root.querySelectorAll('[data-kq-step]'), function (el) {
    stepEls[el.getAttribute('data-kq-step')] = el;
  });

  function currentEl() { return stepEls[STEPS[index].id]; }

  /* ---------- render ---------- */
  function paintSelection(el) {
    var field = STEPS[index].field;
    if (!field) return;
    var chosen = answers[field];
    Array.prototype.forEach.call(el.querySelectorAll('[data-kq-value]'), function (b) {
      b.classList.toggle('is-selected', b.getAttribute('data-kq-value') === chosen);
    });
  }

  function paintChrome() {
    var step = STEPS[index];
    var vis = visibleSteps();
    var pos = vis.indexOf(step) + 1;
    var total = vis.length;

    if (bar) bar.style.transform = 'scaleX(' + (total ? pos / total : 0) + ')';
    if (countEl) countEl.textContent = step.terminal ? '' : 'Step ' + pos + ' of ' + total;
    if (backBtn) backBtn.hidden = history.length === 0 || !!step.terminal;
  }

  function show(el) {
    Object.keys(stepEls).forEach(function (k) { stepEls[k].hidden = true; });
    el.hidden = false;
  }

  /* Reproduces the Keeps mount animation on the slide container. */
  function animateIn() {
    slides.classList.remove('is-leaving', 'is-entered');
    slides.classList.add('is-entering');
    void slides.offsetWidth;                     /* force reflow before the transition */
    slides.classList.remove('is-entering');
    slides.classList.add('is-entered');
    window.setTimeout(function () {
      slides.style.willChange = 'auto';
    }, ENTER_MS + ENTER_DELAY + 50);
  }

  function render() {
    var step = STEPS[index];
    var el = currentEl();
    if (!el) return;
    show(el);
    paintSelection(el);
    paintChrome();
    animateIn();

    if (step.id === 'analysis') fillProfile();
    if (step.loader) runLoader(el, step.loader);

    var focusable = el.querySelector('input, button');
    if (focusable && step.id === 'lead') { try { focusable.focus({ preventScroll: true }); } catch (e) {} }

    /* Not on the first paint — scrolling on load would yank the page away from
       wherever the visitor actually landed. */
    if (booted) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    booted = true;
    saveProgress();
  }

  /* ---------- navigation ---------- */
  function goTo(nextIdx) {
    if (busy) return;
    if (nextIdx >= STEPS.length) return finish();
    busy = true;
    slides.classList.remove('is-entered', 'is-entering');
    slides.classList.add('is-leaving');
    window.setTimeout(function () {
      index = nextIdx;
      busy = false;
      render();
    }, LEAVE_MS);
  }

  function advance() {
    history.push(index);
    goTo(nextIndex(index));
  }

  function back() {
    if (!history.length || busy) return;
    goTo(history.pop());
  }

  /* ---------- interactions ---------- */
  root.addEventListener('click', function (ev) {
    var opt = ev.target.closest('[data-kq-value]');
    if (opt && root.contains(opt)) {
      if (busy) return;
      var field = STEPS[index].field;
      if (field) {
        setAnswer(field, opt.getAttribute('data-kq-value'));
        paintSelection(currentEl());   /* Keeps flashes the selected state during the fade */
      }
      advance();
      return;
    }

    var skip = ev.target.closest('[data-kq-skip]');
    if (skip && root.contains(skip)) {
      if (busy) return;
      var f = STEPS[index].field;
      if (f) setAnswer(f, skip.getAttribute('data-kq-skip'));
      advance();
      return;
    }

    if (ev.target.closest('[data-kq-lead-submit]')) { ev.preventDefault(); submitLead(); return; }
    if (ev.target.closest('[data-kq-skip-back]')) { ev.preventDefault(); back(); return; }
    if (ev.target.closest('[data-kq-back]'))      { ev.preventDefault(); back(); return; }
    if (ev.target.closest('[data-kq-next]'))      { ev.preventDefault(); advance(); return; }
  });

  /* ---------- analysis summary ---------- */
  function fillProfile() {
    var el = stepEls.analysis;
    if (!el) return;
    Array.prototype.forEach.call(el.querySelectorAll('[data-kq-fill]'), function (node) {
      var key = node.getAttribute('data-kq-fill');
      node.textContent = answers[key] || '—';
    });
  }

  /* ---------- loaders ---------- */
  var loaderTimer = null;
  function runLoader(el, spec) {
    window.clearInterval(loaderTimer);
    var pct = el.querySelector('[data-kq-pct]');
    var items = el.querySelectorAll('.kq-loader-item');
    var t0 = null;
    var span = spec.to - spec.from;

    loaderTimer = window.setInterval(function () {
      if (t0 === null) t0 = Date.now();
      var p = Math.min(1, (Date.now() - t0) / spec.ms);
      var value = Math.round(spec.from + span * p);
      if (pct) pct.textContent = value + '%';

      var active = Math.min(items.length - 1, Math.floor(p * items.length));
      Array.prototype.forEach.call(items, function (li, i) {
        li.classList.toggle('is-done', i < active || p === 1);
        li.classList.toggle('is-active', i === active && p < 1);
      });

      if (p === 1) {
        window.clearInterval(loaderTimer);
        window.setTimeout(function () {
          if (spec.last) finish(); else advance();
        }, 420);
      }
    }, 60);
  }

  /* ---------- lead capture ----------
     There is no <form> element on the lead step, by design. A form can submit
     natively — slow script load, an extension, Enter pressed mid-flight — and
     that native POST races the JS: Shopify 302s to return_to and the visitor is
     thrown out of the quiz part-way through the closing loader. Without a form
     there is nothing to submit natively and the race cannot happen.

     The capture is fired and forgotten; the flow advances immediately. Making
     the loader wait on the network would couple a 4s animation to an
     unpredictable round trip, and a failed capture must never cost the sale. */
  var submitting = false;

  function leadFields() {
    var wrap = stepEls.lead;
    return {
      wrap: wrap,
      name: wrap.querySelector('[data-kq-lead-name]'),
      email: wrap.querySelector('[data-kq-lead-email]'),
      error: wrap.querySelector('[data-kq-lead-error]'),
      button: wrap.querySelector('[data-kq-lead-submit]')
    };
  }

  function postLead(name, email) {
    /* Hand-built because there is no form to serialise. These are the fields
       Shopify's /contact endpoint expects from a customer form. */
    var body = new FormData();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[first_name]', name);
    body.append('contact[email]', email);
    body.append('contact[tags]', 'keep-my-hair-quiz');
    body.append('contact[note]', summaryNote());
    /* Cloudflare bot rules on this store reject some automated POSTs to
       /contact outright, so a non-2xx is expected often enough that it must
       stay non-fatal. */
    fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) console.warn('[kq] lead not captured (' + r.status + ')'); })
      .catch(function (e) { console.warn('[kq] lead not captured:', e && e.message); });
  }

  function submitLead() {
    if (submitting) return;
    var f = leadFields();
    var name = (f.name && f.name.value || '').trim();
    var email = (f.email && f.email.value || '').trim();
    if (!name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      if (f.error) f.error.hidden = false;
      var focusEl = name ? f.email : f.name;
      if (focusEl) { try { focusEl.focus(); } catch (e) {} }
      return;
    }
    if (f.error) f.error.hidden = true;
    submitting = true;
    if (f.button) { f.button.disabled = true; f.button.textContent = 'Sending…'; }
    postLead(name, email);
    advance();
  }

  /* Enter anywhere in the lead fields should behave like the button. */
  root.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    if (!ev.target.closest || !ev.target.closest('[data-kq-lead]')) return;
    ev.preventDefault();
    submitLead();
  });

  function summaryNote() {
    return ['goal', 'stage', 'picture', 'duration', 'comments', 'treated', 'results', 'priority']
      .map(function (k) { return k + ': ' + (answers[k] || '—'); })
      .join(' | ');
  }

  /* ---------- routing ----------
     Keeps: treatmentType x priority -> one of four product ids.
     Here (no treatment-type step): the "simple & affordable" answer maps to the
     one-month Operator, everything else to the three-month Forerunner. */
  function recommendation() {
    return answers.priority === 'Simple & Affordable' ? 'operator' : 'forerunner';
  }

  function finish() {
    clearProgress();
    var plan = recommendation();
    var url = CFG.pdpUrl || '/';
    var q = [
      'plan=' + encodeURIComponent(plan),
      'utm_source=quiz',
      'utm_medium=onsite',
      'utm_campaign=keep-my-hair-quiz',
      'utm_content=' + encodeURIComponent(answers.priority || 'unset')
    ].join('&');
    window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + q;
  }

  /* ---------- boot ---------- */
  readStore();
  restoreProgress();
  render();
  if (backBtn) backBtn.hidden = true;
})();
